import loc from 'owa-localize';
import { getFailedInsertLinkIds } from '../utils/getFailedInsertLinkIds';
import { getPendingInsertLinkIds } from '../utils/getPendingInsertLinkIds';
import {
    CouldNotLoadTitle,
    FinishLoadingTitle,
    LoadingTitle,
    SaveBlockDialogCancelButtonText,
    SaveBlockDialogCloseAnywayButtonText,
    SaveBlockDialogCloseButtonText,
} from './insertLinksBlockDialog.locstring.json';

export type GetBlockDialogOnSaveStringsType = typeof getBlockDialogOnSaveStrings;

export function getBlockDialogOnSaveStrings(
    insertLinksIds: string[]
): { title: string; okButtonText: string; cancelButtonText: string } {
    const pendingIds: string[] = getPendingInsertLinkIds(insertLinksIds);
    if (pendingIds.length > 0) {
        return {
            title: loc(LoadingTitle),
            okButtonText: loc(SaveBlockDialogCloseAnywayButtonText),
            cancelButtonText: loc(SaveBlockDialogCancelButtonText),
        };
    }

    const failedIds: string[] = getFailedInsertLinkIds(insertLinksIds);
    if (failedIds.length > 0) {
        return {
            title: loc(CouldNotLoadTitle),
            okButtonText: loc(SaveBlockDialogCloseAnywayButtonText),
            cancelButtonText: loc(SaveBlockDialogCancelButtonText),
        };
    }

    return {
        title: loc(FinishLoadingTitle),
        okButtonText: loc(SaveBlockDialogCloseButtonText),
        cancelButtonText: loc(SaveBlockDialogCancelButtonText),
    };
}
